import { media, Body1, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import React, { FunctionComponent } from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { UserAlertHeader } from "@iventis/components";
import { Button } from "@mui/material";
import { PRICING_URL } from "@iventis/utilities";
import { UpgradeType, UpgradeTextContents, UpgradeControls, upgradeTypeToTitleTextMap, upgradeTypeToBodyTextMap } from "./upgrade-components";

export const NoAccessComponent: FunctionComponent<{ upgradeType: UpgradeType; className?: string }> = ({ upgradeType, className }) => {
    const translate = useIventisTranslate();

    return (
        <StyledContainer className={className}>
            <UserAlertHeader>{translate(upgradeTypeToTitleTextMap[upgradeType])}</UserAlertHeader>
            <UpgradeTextContents upgradeType={upgradeType} />
            <UpgradeControls />
        </StyledContainer>
    );
};

export const NoAccessBanner: FunctionComponent<{ upgradeType: UpgradeType; className?: string }> = ({ upgradeType, className }) => {
    const translate = useIventisTranslate();
    return (
        <StyledBanner className={className}>
            <Body1>{translate(upgradeTypeToBodyTextMap[upgradeType])}</Body1>
            <StyledButton {...{ target: "_blank" }} href={PRICING_URL} variant="contained">
                {translate(Content.settings2.upgrade_plan_warnings.view_plans)}
            </StyledButton>
        </StyledBanner>
    );
};

export const NoAccessOverlay = styled(NoAccessComponent)`
    position: absolute;
    top: 25%;
`;

const StyledContainer = styled.div`
    padding: 20px;
    ${media.large} {
        padding: 80px;
    }
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.light50};
    box-sizing: border-box;
    overflow: visible;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;

    text-align: center;
`;

const StyledBanner = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.light50};
    box-sizing: border-box;
    padding: 20px;
    align-items: center;
    flex-wrap: wrap;
    p {
        color: ${(props: { theme: Theme }) => props.theme.primaryColors.focus};
        font-weight: 600;
    }
`;

const StyledButton = styled(Button)`
    margin-left: 10px;
`;
